import axios from 'axios'
import { message } from 'antd'
// import Cookies from 'js-cookie' // js-cookie
import { setKey, getKey } from '@/utils/Cookie'
import { getToken, setToken, removeToken } from '@/utils/Cookie'
import Auth from '@/utils/Auth'
axios.defaults.timeout = 15000
 // axios.defaults.baseURL = 'http://192.168.20.128:8881'
 axios.defaults.baseURL = 'http://182.148.107.4:88/data'

//http request 拦截器

let count = 0
axios.interceptors.request.use(
  config => {
    count += 1
    // console.log(config)
    let IsExcel =
      config.url.includes('/manage/get/excel') ||
      config.url.includes('/manage/get/route/excel')
    let ISTeam =
      config.url.includes('/v1/group/reserve/mobile') ||
      config.url.includes('/v1/mobile/reserve/order')
      let TeamToken = getKey('SCMT-ADMIN-TOKEN')
      let facilityMarking = getKey('facilityMarking');
      if( (!facilityMarking || facilityMarking ==null) &&(!TeamToken || TeamToken == null) && config.url.includes('/v1/user/keyLogin') ==false){
        window.location.href = 'http://piao.scstm.com/' 
        return
      }
 //   let TeamToken = get('SCMT-ADMIN-TOKEN')
    // console.log(TeamToken)
    config.headers = { 'Content-type': 'application/json' ,'requestType':'web'}
    if(config.url.includes("v1/user/mobile/reserve/personal")){
      config.headers = { 'Content-Type': 'multipart/form-data','requestType':'web' }
    }
    
    if (IsExcel) {
      config.responseType = 'blob'
    }
    Auth.getType() //判断个人/团队预约记录
    config.headers['SCMT-ADMIN-TOKEN'] = TeamToken
    if (ISTeam) {
      if (Auth.getType() == 'TeamAppointment') {
        //团队预约记录
        if (TeamToken) {
          config.headers['SCMT-ADMIN-TOKEN'] = TeamToken
        } else {
        }
      }
    }
    // console.log(config)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//http response 拦截器
axios.interceptors.response.use(
  response => {
  //  count -= 1
    // console.log('response')
    // console.log(response)
    // console.log(response.headers)

    setKey(
      'tourist_cookie_authentication',
      response.headers.tourist_cookie_authentication
    )

    // if (response.data.code === 500) {
    //   message.error(response.data.msg)
    //   // return response
    // }
    // if (response.data.code === 0 || response.data.code === 200) {
    // }
    return response.data
  },
  error => {
    count -= 1
    // console.log('error')
    // console.log(error)

    if (count) {
      return Promise.reject(error)
    } else {
      // console.log(error.response)
      let errorResp = error.response
      if (error && errorResp) {
        let { data, status } = errorResp
        switch (status) {
          case 400:
            message.warning(data ? data : '请求失败！')
            break
          case 401:
            removeToken()
            message.warning(
              data.message ? data.message : '登录凭证已失效，请重新登录！'
            )
            setTimeout(() => {
              window.location.href='http://piao.scstm.com/'
            }, 500)
            break
          case 403:
            removeToken()
            message.warn('无权限访问，请重新登录')
            
            window.location.href='http://piao.scstm.com/'
            setTimeout(() => {
              window.location.href='http://piao.scstm.com/'
            }, 500)
            break
          case 500:
            message.warning('当前网络拥堵，请稍后再试!')
            break
          case 502:
          case 503:
          case 504:
            message.warning('当前网络拥堵，请稍后再试')
            break
          default:
            message.warning('当前网络拥堵，请稍后再试')
        }
      } else {
        message.warning('当前预约人数过多，请稍后再试！')
      }
      return Promise.reject(error)
    }
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

const get = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: params })
      .then(response => {
        if (response.code === 500) {
          message.error(response.msg)
        } else {
          resolve(response)
        }
      })
      .catch(err => {
        // message.error(err.message)
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

const post = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data)
      .then(response => {
        if (response.code === 500) {
          message.error(response.msg)
        } else {
          resolve(response)
        }
      })
      .catch(err => {
        // message.error(err.message)
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

const patch = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(response => {
      resolve(response)
    })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

const put = (url, data = {}) => {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(response => {
      resolve(response)
    })
  })
}

// 用于全局的公共函数
const baseFun = {
  // 本地存储
  localSet(obj, key) {
    var newObj = obj
    var str = JSON.stringify(newObj)
    localStorage.setItem(key, str)
  },
  localGet(key) {
    var str = localStorage.getItem(key)
    return JSON.parse(str)
  },
  localClear(key) {
    localStorage.removeItem(key)
  },

  getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return decodeURI(r[2])
    return null
  }
}

export default {
  get,
  post,
  patch,
  put,
  baseFun
}
